import React, {Component} from 'react';
import Pagination from '../Pagination/Pagination';
import {fetchLatestUnits} from '../../actions/latestUnitActions';
import {connect} from "react-redux";
import queryString from 'query-string';
import Unit from '../Dashboard/Unit';
import Loading from '../Shared/Loading';
import './Dashboard.css';

class DashBoard extends Component {

    componentDidMount() {
        let query = this.props.location.search;
        let queryParams = queryString.parse(query);
        let page = typeof queryParams.page !== 'undefined' ? queryParams.page : 1;
        this.props.dispatch(fetchLatestUnits(page));
    };

    componentDidUpdate(prevProps) {
        let query = this.props.location.search;
        let queryParams = queryString.parse(query);
        let nextPage = typeof queryParams.page !== 'undefined' && !isNaN(queryParams.page) ? parseInt(queryParams.page, 10) : 1;
        let prevPage = parseInt(prevProps.pagination.current_page, 10);
        if (prevPage !== nextPage && !this.props.loading) {
            this.props.dispatch(fetchLatestUnits(nextPage));
        }
    }
    render() {
        const {units, pagination, loading} = this.props;
        return (
            <React.Fragment>
                <section className="campaign-view" key={this.props.currentPage}>
                    <div className="campaign-view-header">
                        <h2>Recent Uploads</h2>
                        <div className="campaign-view-right">
                            <Pagination
                                totalRecords={pagination.total_records}
                                pageLimit={pagination.page_limit}
                                currentPage={pagination.current_page}
                                totalPages={pagination.total_pages}
                                loading={loading}
                                history={this.props.history}
                                route="/latest-units"
                            />
                        </div>
                    </div>
                    <div className="upload-wrapper">
                        {loading ? (
                            <Loading/>
                        ) : (
                            <div className="upload-container">
                                {units.map((unit) => (<Unit key={`${unit.unit_type}-${unit.id}`} unit={unit}/>))}
                            </div>
                        )}
                    </div>
                    <div className={`text-right`} style={{display: loading ? 'none' : 'inline-block'}}>
                        <Pagination
                            totalRecords={pagination.total_records}
                            pageLimit={pagination.page_limit}
                            currentPage={pagination.current_page}
                            totalPages={pagination.total_pages}
                            loading={loading}
                            history={this.props.history}
                            route="/latest-units"
                        />
                    </div>

                </section>
            </React.Fragment>
        )
    }
}

const mapStateToProps = state => ({
    units: state.latestUnits.units,
    pagination: state.latestUnits.pagination,
    loading: state.latestUnits.loading,
    first_name: state.user.first_name,
    roles: state.user.roles
});

export default connect(mapStateToProps)(DashBoard);

